module.exports = __webpack_public_path__ + "static/images/circle-clicked.2VGMX7L.svg";